// Fixed master lists — predefined per product spec, not editable in Firestore.
export const DURATIONS = [15, 30, 45, 60, 90, 120];

export const DEFAULT_DURATION = 30;

export const GENDERS = ['Men', 'Women', 'Unisex'];

export const DEFAULT_GENDER = 'Unisex';

// Column order of the service entry grid; also the TSV copy/paste column order.
export const GRID_COLUMNS = ['category', 'service', 'subService', 'gender', 'duration', 'price'];
